import { useContext, useMemo } from "react";
import { useGlobalEnvConfig } from "@environment/GlobalEnvConfigProvider";
import { Trans } from '@lingui/macro';

import { BasicData } from '@App';
import { safeResourceUrl, checkBrandingType, getTextColorClass, getColor } from '@utils/Utils';

import "./style.scss";

const Branding = () => {
    const { REACT_APP_RESOURCE_DOMAIN } = useGlobalEnvConfig();
    const { type, theme, emergency_contact, emergency_contact_name, contact_detail, is_using_new_overrides, contact_detail_type, contact_image_type } = useContext(BasicData);

    const colors = getColor(theme);

    return useMemo(() => (
        <div className='branding'>
            <div className='consultant-wrapper'>
                {(!is_using_new_overrides && contact_detail?.consultant_photo_url_fragment && checkBrandingType(theme, type) === "consultant") &&
                    <div className='consultant-img'>
                        <img src={safeResourceUrl(REACT_APP_RESOURCE_DOMAIN,`/${contact_detail?.consultant_photo_url_fragment}`)} alt="" />
                    </div>
                }

                {(!is_using_new_overrides && contact_detail?.logo_url_fragment && checkBrandingType(theme, type) === "company") &&
                    <div className='company-img'>
                        <img src={safeResourceUrl(REACT_APP_RESOURCE_DOMAIN,`/${contact_detail?.logo_url_fragment}`)} alt="" />
                    </div>
                }

                {(is_using_new_overrides && contact_detail?.logo_url_fragment && contact_image_type === "OperatorIdentity") &&
                    <div className='company-img'>
                        <img src={safeResourceUrl(REACT_APP_RESOURCE_DOMAIN,`/${contact_detail?.logo_url_fragment}`)} alt="" />
                    </div>
                }

                {(is_using_new_overrides && contact_detail?.consultant_photo_url_fragment && contact_image_type === "OperatorUser") &&
                    <div className='consultant-img'>
                        <img src={safeResourceUrl(REACT_APP_RESOURCE_DOMAIN,`/${contact_detail?.consultant_photo_url_fragment}`)} alt="" />
                    </div>
                }

                {(is_using_new_overrides && contact_detail?.logo_url_fragment && contact_image_type === "Operator") &&
                    <div className='company-img'>
                        <img src={safeResourceUrl(REACT_APP_RESOURCE_DOMAIN,`/${contact_detail?.logo_url_fragment}`)} alt="" />
                    </div>
                }

                <div className='consultant-details'>
                    {!is_using_new_overrides &&
                        <h3>{checkBrandingType(theme, type) === "consultant" ? contact_detail?.consultant_name : contact_detail?.company_name}</h3>
                    }

                    {is_using_new_overrides &&
                        <h3>
                            {
                            contact_detail_type === "OperatorIdentity" ? contact_detail?.company_name : 
                            contact_detail_type === "OperatorUser" ? contact_detail?.consultant_name : 
                            contact_detail?.company_name
                            }
                        </h3>
                    }

                    <div className='general-contact'>
                        {contact_detail?.phone && (
                            <div className='general-contact-details-row'>
                                <i className={`icon-phone ${getTextColorClass(colors?.primary)}`} />
                                <p className="break-words"><a href={`tel:${contact_detail.phone}`}>{contact_detail.phone}</a></p>
                            </div>
                        )}

                        {contact_detail?.email && (
                            <div className='general-contact-details-row'>
                                <i className={`icon-mail ${getTextColorClass(colors?.primary)}`} />
                                <p className="break-words"><a href={`mailto:${contact_detail.email}`}>{contact_detail.email}</a></p>
                            </div>
                        )}

                        {contact_detail?.website && (
                            <div className='general-contact-details-row'>
                                <i className={`icon-globe ${getTextColorClass(colors?.primary)}`} />
                                <p className="break-words"><a href={contact_detail.website} target="_blank" rel='noreferrer'>{contact_detail.website}</a></p>
                            </div>
                        )}
                    </div>

                    {emergency_contact && (
                        <div className='emergency-contact general-contact-details-row'>
                            <i className={`icon-info ${getTextColorClass(colors?.primary)}`} />
                            <p className="break-words">{emergency_contact_name ? `${emergency_contact_name} - ` : ''}<Trans>Emergency Contact</Trans>: <br /> {emergency_contact}</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    ), [REACT_APP_RESOURCE_DOMAIN, contact_detail, is_using_new_overrides, contact_detail_type, contact_image_type, type, theme, emergency_contact, emergency_contact_name, colors.primary])
}

export default Branding;